import React, { useState } from "react";
import "./AddLocationForm.css"; // Ensure proper styling

const AddLocationForm = ({ onClose, onLocationAdded }) => {
  const [formData, setFormData] = useState({
    location_name: "",
    address: "",
  });

  const [error, setError] = useState(null);

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.location_name || !formData.address) {
      setError("All fields are required.");
      return;
    }

    try {
      const response = await fetch("/api/locations/add-location", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to add location.");
      }

      alert("✅ Location added successfully!");
      setTimeout(() => {
        onLocationAdded(); // Refresh location list
        onClose(); // Close modal
      }, 300);
    } catch (error) {
      console.error("❌ Error adding location:", error.message);
      setError(error.message || "An error occurred.");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        {/* Close Button */}
        <button className="close-button" onClick={onClose}>✖</button>

        <h3>Add Location</h3>

        <form onSubmit={handleSubmit}>

          <div className="form-group">
            <label className="add-user-label" htmlFor="location-name">Location Name:</label>
            <input 
              id="location-name"
              className="add-user-input" 
              type="text" 
              name="location_name" 
              value={formData.location_name} 
              onChange={handleChange} 
              required 
            />
          </div>

          <div className="form-group">
            <label className="add-user-label" htmlFor="location-address">Address:</label>
            <input 
              id="location-address"
              className="add-user-input" 
              type="text" 
              name="address" 
              value={formData.address} 
              onChange={handleChange} 
              required 
            />
          </div>

          {/* Display error message */}
          {error && <p className="error-message">{error}</p>}

          <button type="submit" className="submit-btn">Add Location</button>
        </form>
      </div>
    </div>
  );
};

export default AddLocationForm;